import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import IntroVideo from './pages/IntroVideo';
import ResetPasswordPage from './pages/ResetPasswordPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Msg #797 batch — Intro video plays first, once per session. */}
          <Route path="/" element={<IntroVideo />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/chat" element={<ChatPage />} />
          {/* Msg #986 — Password-reset landing (token from email). */}
          <Route path="/reset" element={<ResetPasswordPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
